module.exports = {"true":"Yes","false":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/general.json
// module id = wYVR
// module chunks = 1